import { generatePath, Redirect, Route } from 'react-router-dom'
import Content from 'app/Content'
import {
  reportsInsightsPath,
  reportsPath,
  reportsPerformancePath,
} from 'app/navigation/paths'
import CustomSwitch from 'app/router/Switch'

import { useAppSelector } from 'common/hooks/redux'

import Insights from './insights/Insights'
import Performance from './performance/Performance'

const Reports = () => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const performanceSubroute = generatePath(reportsPerformancePath, {
    accountId,
  })
  const insightsSubroute = generatePath(reportsInsightsPath, {
    accountId,
  })

  return (
    <Content>
      <CustomSwitch>
        <Route path={reportsPerformancePath}>
          <Performance />
        </Route>
        <Route path={reportsInsightsPath}>
          <Insights />
        </Route>
        <Redirect exact from={reportsPath} to={performanceSubroute} />
        <Redirect exact from="/reports" to={performanceSubroute} />
        <Redirect exact from="/reports/performance" to={performanceSubroute} />
        <Redirect exact from="/reports/insights" to={insightsSubroute} />
      </CustomSwitch>
    </Content>
  )
}

export default Reports
